import { render, staticRenderFns } from "./CompaniesPage.vue?vue&type=template&id=77ef14d0&scoped=true"
import script from "./CompaniesPage.vue?vue&type=script&lang=ts"
export * from "./CompaniesPage.vue?vue&type=script&lang=ts"
import style0 from "./CompaniesPage.vue?vue&type=style&index=0&id=77ef14d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef14d0",
  null
  
)

export default component.exports